import React from "react";
import "./project.css";
import Tipcal from "../../assets/tipcal.PNG";
import Antigen from "../../assets/antigen.PNG";
import Hulu from "../../assets/hulu.PNG";
import Glitz from "../../assets/glitz.PNG";
function Project() {
  return (
    <div className="projects">
      <h2>My Projects</h2>

      <div className="grid">
        <a
          href="https://glitz-test.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
          <div className="card">
            <h3>Landing Page for Glitz</h3>
            <p>
              Modern Landing page for an e-commerce website built with react.
              <br />
              This project features as clean dynamic and fast UI. Definitely a
              Must-see!!!
            </p>
            <img src={Glitz} alt="glitz" />
          </div>
        </a>

        <div className="card">
          <h3>Homepage for Antigen</h3>
          <p>
            Built a web page for a medical startup. This project features
            advanced Layout and well positioned responsive images. Also, this
            page was built with the use of a javascript framework and SCSS.
          </p>
          <img src={Antigen} alt="Antigen page screenshot" />
        </div>

        <a
          href="https://banks-tipcalculator.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
          <div className="card">
            <h3>Tip Calculator</h3>
            <p>
              A simple javascript project for tip and percentage calculation.
              Built into a beautiful UI design with a light and dark mode
              toggle. A simple front end project to show functionality in a
              modern soft UI.
            </p>
            <img src={Tipcal} alt="tip-calculator screenshot" />
          </div>
        </a>

        <a
          href="https://banksdev-hulu.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
          <div className="card">
            <h3>Hulu Homepage Clone</h3>
            <p>
              I made a clone of Hulu's landing page with basic html, css. While
              also bringinig the use of animation libraries to create scroll and
              slide animations.
            </p>
            <img src={Hulu} alt="Hulu homepage clone" />
          </div>
        </a>

        <div className="card">
          <h3>Tetris</h3>
          <p></p>
          <img src="" alt="" />
        </div>

        <a
          href="https://github.com/BanksMustapha7/"
          target="_blank"
          rel="noreferrer"
          className="gButton"
        >
          <button className="githubLink">
            Check out more projects on my github space
          </button>
        </a>
      </div>
    </div>
  );
}

export default Project;
